export function getFormattedDate(option) {
  const today = new Date();
  let daysOffset = 0;

  if (option === "today") {
    daysOffset = 0;
  } else if (option === "yesterday") {
    daysOffset = 1;
  } else if (option.match(/^(\d) days ago$/)) {
    daysOffset = parseInt(option, 10);
  }

  today.setDate(today.getDate() - daysOffset);

  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = today.getFullYear();

  return `${day}.${month}.${year}`;
}
